import colors from './colors.js';
export default {
  name: 'dark',
  colors: {
    primary: colors.cornflower400,
    primaryShade: colors.cornflower500,
    primaryLight: colors.cornflower300,
    primaryDark: colors.cornflower900,
    foreground: {
      primary: colors.white,
      secondary: colors.eucalyptus300,
      tertiary: colors.eucalyptus500,
      destructive: colors.orchid500,
      destructiveDark: colors.orchid800,
      warning: colors.dandelion500,
      warningDark: colors.dandelion800,
      success: colors.dahlia500,
      successDark: colors.dahlia800,
      info: colors.cornflower800,
      splash: colors.black,
      disabled: colors.eucalyptus400
    },
    background: {
      primary: colors.black,
      secondary: colors.cornflower900,
      tertiary: colors.eucalyptus100,
      quaternary: colors.eucalyptus100,
      splash: colors.wildrose200,
      success: colors.dahlia100,
      warning: colors.dandelion100,
      destructive: colors.orchid100,
      info: colors.cornflower100,
      disabled: colors.eucalyptus700
    },
    swatch: {
      gray: colors.eucalyptus400,
      silver: colors.eucalyptus200,
      white: colors.white,
      black: colors.black,
      red: colors.rose,
      blue: colors.cornflower500,
      green: colors.amaranth,
      yellow: colors.dandelion500,
      orange: colors.tulip,
      purple: colors.lavender,
      brown: colors.tobacco
    },
    border: colors.eucalyptus700,
    separator: colors.eucalyptus700
  },
  tokens: {
    focusColor: colors.cornflower300 + '80',
    inputControlDisabledBackground: colors.eucalyptus200,
    inputDisabledBackground: colors.eucalyptus100,
    inputDisabledBorder: colors.eucalyptus300,
    // actionButton
    buttonPrimaryColor: colors.cornflower500,
    buttonPrimaryForeground: colors.white,
    buttonPrimaryHover: colors.cornflower600,
    buttonPrimaryAlternateColor: colors.white,
    buttonPrimaryAlternateForeground: colors.black,
    buttonPrimaryAlternateHover: colors.eucalyptus100,
    buttonControlForeground: colors.white,
    buttonControlHover: colors.eucalyptus800,
    buttonControlBorder: colors.eucalyptus400,
    buttonLinkColor: colors.cornflower400,
    buttonLinkForeground: colors.white,
    buttonLinkHover: colors.white,
    buttonFunctionForeground: colors.white,
    buttonFunctionForegroundAlternate: colors.white,
    buttonFunctionHover: colors.eucalyptus800,
    buttonFunctionHoverAlternate: colors.eucalyptus800,
    buttonFunctionHoverForeground: colors.white,
    buttonPrimaryLoading: colors.white,
    buttonPrimaryAlternateLoading: colors.black,
    buttonControlLoading: colors.cornflower300,
    // actionLink
    linkPrimaryForeground: colors.cornflower300,
    linkPrimaryHover: colors.cornflower400,
    linkPrimaryAlternateForeground: colors.white,
    linkControlForeground: colors.eucalyptus300,
    linkControlHover: colors.eucalyptus200,
    // floatingActionButton
    actionButtonDisabledForeground: colors.eucalyptus400,
    actionButtonPrimaryActiveBackground: colors.cornflower600,
    actionButtonPrimaryActiveBorder: colors.cornflower600,
    actionButtonPrimaryBackground: colors.cornflower500,
    actionButtonPrimaryBorder: colors.cornflower500,
    actionButtonPrimaryDisabledBackground: colors.eucalyptus200,
    actionButtonPrimaryDisabledBorder: colors.eucalyptus200,
    actionButtonPrimaryForeground: colors.white,
    actionButtonPrimaryHoverBackground: colors.cornflower600,
    actionButtonPrimaryHoverBorder: colors.cornflower600,
    actionButtonPrimaryAlternateActiveBackground: colors.eucalyptus100,
    actionButtonPrimaryAlternateActiveBorder: colors.eucalyptus100,
    actionButtonPrimaryAlternateBackground: colors.white,
    actionButtonPrimaryAlternateBorder: colors.white,
    actionButtonPrimaryAlternateDisabledBackground: colors.eucalyptus300,
    actionButtonPrimaryAlternateDisabledBorder: colors.eucalyptus300,
    actionButtonPrimaryAlternateForeground: colors.black,
    actionButtonPrimaryAlternateHoverBackground: colors.eucalyptus100,
    actionButtonPrimaryAlternateHoverBorder: colors.eucalyptus100,
    actionButtonControlActiveBackground: colors.eucalyptus900,
    actionButtonControlActiveBorder: colors.eucalyptus400,
    actionButtonControlBackground: colors.black,
    actionButtonControlBorder: colors.eucalyptus400,
    actionButtonControlDisabledBackground: colors.black,
    actionButtonControlDisabledBorder: colors.eucalyptus200,
    actionButtonControlForeground: colors.white,
    actionButtonControlHoverBackground: colors.eucalyptus900,
    actionButtonControlHoverBorder: colors.eucalyptus400,
    actionButtonFunctionActiveBackground: colors.eucalyptus900,
    actionButtonFunctionActiveBorder: colors.eucalyptus900,
    actionButtonFunctionBackground: 'transparent',
    actionButtonFunctionBorder: 'transparent',
    actionButtonFunctionDisabledBackground: 'transparent',
    actionButtonFunctionDisabledBorder: 'transparent',
    actionButtonFunctionForeground: colors.white,
    actionButtonFunctionHoverBackground: colors.eucalyptus900,
    actionButtonFunctionHoverBorder: colors.eucalyptus900
  }
};